export default {
  metadata: {
    version: '2.0.0',
    id: 'badge-2.0.0',
    name: 'JDSBadgeV2'
  },
  hierarchy: {
    container: [
      {
        'children-container': ['children-slot']
      },
      {
        'badge-container': [
          'jds_badge_v2_information',
          'jds_badge_v2_brand',
          'jds_badge_v2_notification',
          'jds_badge_v2_status'
        ]
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      hidden: false
    },
    'badge-container': {
      'z-index': 1
    },
    jds_badge_v2_information: {
      hidden: true,
      size: 'medium'
    },
    jds_badge_v2_brand: {
      hidden: true,
      size: 'medium'
    },
    jds_badge_v2_notification: {
      hidden: true,
      size: 'medium'
    },
    jds_badge_v2_status: {
      hidden: true,
      size: 'medium'
    },
    'children-container': {
      hidden: false,
      'z-index': 0
    }
  },
  variant: {
    kind: {
      information: {
        jds_badge_v2_information: {
          hidden: false
        }
      },
      brand: {
        jds_badge_v2_brand: {
          hidden: false
        }
      },
      notification: {
        jds_badge_v2_notification: {
          hidden: false
        }
      },
      status: {
        jds_badge_v2_status: {
          hidden: false
        }
      }
    },
    placement: {
      top: {
        container: {
          'justify-content': '{justifyContent.center}',
          'align-items': '{alignItems.start}'
        }
      },
      top_end: {
        container: {
          'justify-content': '{justifyContent.end}',
          'align-items': '{alignItems.start}'
        }
      },
      bottom_start: {
        container: {
          'justify-content': '{justifyContent.start}',
          'align-items': '{alignItems.end}'
        }
      },
      bottom: {
        container: {
          'justify-content': '{justifyContent.center}',
          'align-items': '{alignItems.end}'
        }
      },
      bottom_end: {
        container: {
          'justify-content': '{justifyContent.end}',
          'align-items': '{alignItems.end}'
        }
      },
      left: {
        container: {
          'justify-content': '{justifyContent.start}',
          'align-items': '{alignItems.center}'
        }
      },
      right: {
        container: {
          'justify-content': '{justifyContent.end}',
          'align-items': '{alignItems.center}'
        }
      }
    },
    size: {
      'xtra-small': {
        jds_badge_v2_information: {
          size: 'xtra-small'
        },
        jds_badge_v2_brand: {
          size: 'medium'
        },
        jds_badge_v2_notification: {
          size: 'xtra-small'
        },
        jds_badge_v2_status: {
          size: 'xtra-small'
        }
      },
      small: {
        jds_badge_v2_information: {
          size: 'small'
        },
        jds_badge_v2_brand: {
          size: 'medium'
        },
        jds_badge_v2_notification: {
          size: 'small'
        },
        jds_badge_v2_status: {
          size: 'small'
        }
      },
      large: {
        jds_badge_v2_information: {
          size: 'large'
        },
        jds_badge_v2_brand: {
          size: 'large'
        },
        jds_badge_v2_notification: {
          size: 'large'
        },
        jds_badge_v2_status: {
          size: 'large'
        }
      },
      'xtra-large': {
        jds_badge_v2_information: {
          size: 'xtra-large'
        },
        jds_badge_v2_brand: {
          size: 'xtra-large'
        },
        jds_badge_v2_notification: {
          size: 'xtra-large'
        },
        jds_badge_v2_status: {
          size: 'xtra-large'
        }
      },
      'xtra-xtra-large': {
        jds_badge_v2_information: {
          size: 'xtra-xtra-large'
        },
        jds_badge_v2_brand: {
          size: 'xtra-xtra-large'
        },
        jds_badge_v2_notification: {
          size: 'xtra-xtra-large'
        },
        jds_badge_v2_status: {
          size: 'xtra-xtra-large'
        }
      },
      'xtra-xtra-xtra-large': {
        jds_badge_v2_information: {
          size: 'xtra-xtra-xtra-large'
        },
        jds_badge_v2_brand: {
          size: 'xtra-xtra-xtra-large'
        },
        jds_badge_v2_notification: {
          size: 'xtra-xtra-xtra-large'
        },
        jds_badge_v2_status: {
          size: 'xtra-xtra-xtra-large'
        }
      },
      'xtra-xtra-xtra-xtra-large': {
        jds_badge_v2_information: {
          size: 'xtra-xtra-xtra-xtra-large'
        },
        jds_badge_v2_brand: {
          size: 'xtra-xtra-xtra-xtra-large'
        },
        jds_badge_v2_notification: {
          size: 'xtra-xtra-xtra-xtra-large'
        },
        jds_badge_v2_status: {
          size: 'xtra-xtra-xtra-xtra-large'
        }
      }
    },
    _hasChildrenSlot: {
      false: {
        'children-container': {
          hidden: true
        },
        'badge-container': {
          'z-index': 0
        }
      }
    }
  },
  api: {
    config: {
      kind: {
        values: ['information', 'brand', 'notification', 'status']
      },
      placement: {
        values: [
          'top_start',
          'top',
          'top_end',
          'bottom_start',
          'bottom',
          'bottom_end',
          'left',
          'right'
        ]
      },
      size: {
        values: [
          'medium',
          'xtra-small',
          'small',
          'large',
          'xtra-large',
          'xtra-xtra-large',
          'xtra-xtra-xtra-large',
          'xtra-xtra-xtra-xtra-large'
        ]
      },
      _hasChildrenSlot: {
        values: [true, false]
      }
    },
    data: {
      'badge-container': {
        'translate-x': {
          type: 'size',
          name: 'offsetLeft'
        },
        'translate-y': {
          type: 'size',
          name: 'offsetTop'
        }
      },
      jds_badge_v2_information: {
        label: {
          type: 'string',
          name: 'label'
        },
        icon: {
          type: 'icon',
          name: 'icon'
        },
        background: {
          type: 'color',
          name: 'backgroundInfoColor'
        },
        image: {
          type: 'image',
          name: 'image'
        },
        kind: {
          type: 'JDSBadgeV2Information.kind',
          name: 'informationKind'
        },
        color: {
          type: 'JDSBadgeV2Information.color',
          name: 'color'
        },
        appearance: {
          type: 'JDSBadgeV2Information.appearance',
          name: 'appearance'
        },
        border: {
          type: 'boolean',
          name: 'border'
        }
      },
      jds_badge_v2_brand: {
        label: {
          type: 'string',
          name: 'label'
        },
        image: {
          type: 'image',
          name: 'image'
        },
        kind: {
          type: 'JDSBadgeV2Brand.kind',
          name: 'brandKind'
        },
        emphasis: {
          type: 'JDSBadgeV2Brand.emphasis',
          name: 'brandEmphasis'
        }
      },
      jds_badge_v2_notification: {
        label: {
          type: 'string',
          name: 'label'
        },
        kind: {
          type: 'JDSBadgeV2Notification.kind',
          name: 'notificationKind'
        },
        border: {
          type: 'boolean',
          name: 'border'
        }
      },
      jds_badge_v2_status: {
        label: {
          type: 'string',
          name: 'label'
        },
        kind: {
          type: 'JDSBadgeV2Status.kind',
          name: 'statusKind'
        },
        status: {
          type: 'JDSBadgeV2Status.status',
          name: 'status'
        },
        border: {
          type: 'boolean',
          name: 'border'
        }
      }
    },
    children: {
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    a11y: {
      jds_badge_v2_information: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_badge_v2_brand: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_badge_v2_status: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_badge_v2_notification: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
